import React, { Component, useState, useEffect } from "react"
import { BrowserRouter as Router, Route, useLocation, Switch } from "react-router-dom"
import { Redirect } from "react-router-dom"
import jwt from "jsonwebtoken"

import AuthdLayout from "./Layouts/AuthdLayout/"
import NonAuthdLayout from "./Layouts/NonAuthdLayout/"
import "./assets/scss/theme.scss"

import Dashboard from "./Pages/Dashboard"
import Register from "./Pages/Register"
import Login from "./Pages/Login"
import Logout from "./Pages/Logout"
import ForgotPassword from "./Pages/ForgotPassword"
import Learning from "./Pages/Learning"
import Course from "./Pages/Course"
import Settings from "./Pages/Settings"
import Trending from "./Pages/Trending"
import Activity from "./Pages/Activity"
import CreateCollection from "./Pages/CreateCollection"
import CreateMinter from "./Pages/CreateMinter"
import MintNFT from "./Pages/MintNFT"
import ZkMintNFT from "./Pages/ZksMintNFT"
import PaymasterAdmin from "./Pages/Paymaster"
import IdeaMinter from "./Pages/IdeaMint"
import IdeaViewer from "./Pages/IdeaViewVote"
import Admin from "./Pages/Admin"
import AdminNew from "./Pages/AdminNew"
import AdminResources from "./Pages/AdminResources"
import Credits from "./Pages/Credits"
import ValidateNFT from "./Pages/ValidateNFT"
import ValidateKYC from "./Pages/ValidateKYC"
import ValidateCommunityNFT from "./Pages/ValidateCommunityNFT"
import Trading from "./Pages/Trading"
import CreateNewTrading from "./Pages/CreateNewTrading"
import TradingDetail from "./Pages/TradingDetail"
import ProfilePage from "./Pages/Profile"
// import Leaderboard from "./Pages/Leaderboard"
import Token from "./Pages/Token"
import Vesting from "./Pages/Vesting"
import Payment from "./Pages/Payment/Payment"
import Staking from "./Pages/Stake"
import StakingSOB from "./Pages/Stake/sob"
import StakingILNP from "./Pages/Stake/Prestaking"
import Special from "./Pages/Special/Special"
import Voting from "./Pages/Voting"
import VotingNew from "./Pages/VotingNew"
import Bridge from "./Pages/Bridge"
import ZkCompanions from "./Pages/zkCompanions"
import ZkMinter from "./Pages/NFTMint"
import ZkViewer from "./Pages/NFTView"
// import ZkNftCard from "./Components/NftCard/ZkNftCard"
import Tasks from "./Pages/Tasks"
import ValidateStakerCode from "./Pages/ValidateStakerCode"
import Survey from "./Pages/Surveys/Survey"
import Surveys from "./Pages/Surveys"
import TokenGating from "./Pages/TokenGating"
import TokenGatingDetail from "./Pages/TokenGatingDetail"
import NFTSale from "./Pages/NFTSale"
import LootboxDetail from "./Pages/LootboxDetail"
import TokenDetails from "./Pages/TokenDetails"

const AppRoute = ({ Component, Layout, ...rest }) => (
    <Route
        {...rest}
        render={(props) => (
            <Layout>
                <Component {...props} />
            </Layout>
        )}
    />
)

const ProtectedRoute = ({ Level, Component, ...rest }) => {
    const authLevel = { new: 1, tester: 2, developer: 3, admin: 5 }
    const [auth, setAuth] = useState(10)
    const [queryParam, setQueryParam] = useState("")
    const [search, setSearch] = useState("")
    const [hash, setHash] = useState("")
    const location = useLocation()

    useEffect(() => {
        setAuth(0)
        setQueryParam(location.pathname.slice(1))
        setSearch(location.search)
        setHash(location.hash)
        if (localStorage.jwtToken) {
            try {
                var decoded = jwt.decode(localStorage.jwtToken)
                if (new Date().getTime() > Number(decoded.exp) * 1000) {
                    localStorage.removeItem("jwtToken")
                } else {
                    setAuth(authLevel[decoded.type])
                }
            } catch {}
        }
    }, localStorage)

    return (
        <Route
            {...rest}
            render={(props) =>
                auth >= Level ? (
                    <AuthdLayout>
                        <Component {...props} />
                    </AuthdLayout>
                ) : queryParam !== "" ? (
                    <Redirect to={{ pathname: "/login", state: { referrer: queryParam, search, hash } }} />
                ) : (
                    <Redirect to={{ pathname: "/login" }} />
                )
            }
        />
    )
}

class App extends Component {
    constructor(props) {
        super(props)
        this.state = { authenticated: true }
    }

    componentDidMount() {}

    render() {
        return (
            <Router>
                <Switch>
                    <ProtectedRoute Level={1} exact path="/" Component={Dashboard} />
                    <ProtectedRoute Level={1} exact path="/learning" Component={Learning} />
                    <ProtectedRoute Level={1} exact path="/course" Component={Course} />
                    <ProtectedRoute Level={1} exact path="/settings" Component={Settings} />
                    <ProtectedRoute Level={1} exact path="/trending" Component={Trending} />
                    <ProtectedRoute Level={1} exact path="/activity" Component={Activity} />
                    <ProtectedRoute Level={1} exact path="/createcollection" Component={CreateCollection} />
                    <ProtectedRoute Level={1} exact path="/createminter" Component={CreateMinter} />
                    // <ProtectedRoute Level={2} exact path="/mintnft" Component={ZkMintNFT} />
                    <ProtectedRoute Level={5} exact path="/admin" Component={Admin} />
                    <ProtectedRoute Level={5} exact path="/admin2" Component={AdminNew} />
                    <ProtectedRoute Level={5} exact path="/admin-resources" Component={AdminResources} />
                    <ProtectedRoute Level={1} exact path="/credits" Component={Credits} />
                    {/* <ProtectedRoute Level={1} exact path="/validatenft" Component={ValidateNFT} /> */}
                    <ProtectedRoute Level={1} exact path="/communitykyc" Component={ValidateKYC} />
                    <ProtectedRoute Level={1} exact path="/tokengating" Component={TokenGating} />
                    <ProtectedRoute Level={1} exact path="/tokengating/:address" Component={TokenGatingDetail} />
                    <ProtectedRoute Level={1} exact path="/validatecknft" Component={ValidateCommunityNFT} />
                    <ProtectedRoute Level={1} exact path="/trading" Component={Trading} />
                    <ProtectedRoute Level={1} exact path="/trading/new" Component={CreateNewTrading} />
                    <ProtectedRoute Level={1} exact path="/nft/:id" Component={TradingDetail} />
                    <ProtectedRoute Level={1} exact path="/profile" Component={ProfilePage} />
                    <ProtectedRoute Level={1} exact path="/leaderboard" Component={Dashboard} />
                    <ProtectedRoute Level={1} exact path="/tasks" Component={Tasks} />
                    <ProtectedRoute Level={1} exact path="/voting" Layout={AuthdLayout} Component={Voting} />
                    <ProtectedRoute Level={1} exact path="/stakevoting" Layout={AuthdLayout} Component={VotingNew} />
                    <AppRoute exact path="/nftsale" Layout={AuthdLayout} Component={NFTSale} />
                    <AppRoute exact path="/nftsale/:id" Layout={AuthdLayout} Component={LootboxDetail} />
                    <AppRoute exact path="/nftsaletest" Layout={AuthdLayout} Component={NFTSale} />
                    <AppRoute exact path="/nftsaletest/:id" Layout={AuthdLayout} Component={LootboxDetail} />
                    <AppRoute exact path="/tokendetails/:address/:id" Layout={AuthdLayout} Component={TokenDetails} />
                    <AppRoute exact path="/token" Layout={AuthdLayout} Component={Token} />
                    <AppRoute exact path="/zkmintnft" Layout={AuthdLayout} Component={ZkMinter} />
                    <AppRoute exact path="/paymaster" Layout={AuthdLayout} Component={PaymasterAdmin} />
                    <AppRoute exact path="/ideamint" Layout={AuthdLayout} Component={IdeaMinter} />
                    <AppRoute exact path="/ideaviewer" Layout={AuthdLayout} Component={IdeaViewer} />
                    <AppRoute path="/ideaviewer/:id" Layout={AuthdLayout} Component={IdeaViewer} />
                    <AppRoute exact path="/zkviewnft" Layout={AuthdLayout} Component={ZkViewer} />
                    <AppRoute path="/zkviewnft/:id" Layout={AuthdLayout} Component={ZkViewer} />
                    <AppRoute exact path="/vesting" Layout={AuthdLayout} Component={Vesting} />
                    <AppRoute exact path="/special" Layout={AuthdLayout} Component={Special} />
                    <AppRoute exact path="/payment" Layout={AuthdLayout} Component={Payment} />
                    <AppRoute exact path="/staking/:pool?" Layout={AuthdLayout} Component={Staking} />
                    <AppRoute exact path="/stakingsob/:pool?" Layout={AuthdLayout} Component={StakingSOB} />
                    <AppRoute exact path="/nodeprestaking/:pool?" Layout={AuthdLayout} Component={StakingILNP} />
                    <AppRoute exact path="/survey" Layout={AuthdLayout} Component={Survey} />
                    <AppRoute exact path="/surveys/:survey?" Layout={AuthdLayout} Component={Surveys} />
                    <AppRoute exact path="/bridge" Layout={AuthdLayout} Component={Bridge} />
                    <AppRoute exact path="/zkcmint" Layout={AuthdLayout} Component={ZkCompanions} />
                    <AppRoute exact path="/stakercode" Layout={AuthdLayout} Component={ValidateStakerCode} />
                    <AppRoute exact path="/register" Layout={NonAuthdLayout} Component={Register} />
                    <AppRoute exact path="/logout" Layout={NonAuthdLayout} Component={Logout} />
                    <AppRoute path="/login" Layout={NonAuthdLayout} Component={Login} />
                    <AppRoute exact path="/forgot-password" Layout={NonAuthdLayout} Component={ForgotPassword} />
                    {/* redirect to "/" if url not found */}
                    <Route render={() => <Redirect to="/" />} />
                </Switch>
            </Router>
        )
    }
}

export default App
